/**
 * hexagon-configurator.js
 * Beheert de keuzelogica op de hexagon productpagina.
 * Bouwt het session object en stuurt de klant door naar de editor.
 */

(function () {
  'use strict';

  // ─── State ────────────────────────────────────────────────────────────────
const state = {
    shape:    null,
    material: null,
    size:     null,
    layout:   null,
  };

  // ─── Productvarianten (materiaal x formaat prijslogica) ────────────────────
  // Wordt gevuld vanuit window.hexProductConfig.variants (zie hexagon-product.liquid)
  var productVariants = (window.hexProductConfig && window.hexProductConfig.variants) || [];

  function findVariant(materialValue, sizeValue) {
    if (!materialValue || !sizeValue) return null;
    var matNorm  = String(materialValue).toLowerCase();
    var sizeNorm = String(sizeValue).toLowerCase();
    return productVariants.find(function (v) {
      return v.material && v.size &&
        v.material.toLowerCase() === matNorm &&
        v.size.toLowerCase() === sizeNorm;
    }) || null;
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return '€ ' + amount;
  }

  function updatePriceDisplay() {
    var variant = findVariant(state.material, state.size);
    var priceEl = document.getElementById('hex-price');
    if (!priceEl) return;

    if (variant) {
      priceEl.textContent = formatMoney(variant.price);
    }
    // Als er geen match is (bijv. nog niet beide keuzes gemaakt), laat de huidige prijs staan
  }

function showValidationMessage() {
    var existing = document.getElementById('hex-validation-msg');
    if (existing) return;
    var msg = document.createElement('p');
    msg.id = 'hex-validation-msg';
    msg.textContent = 'Vul alle opties in voordat je verder gaat.';
    msg.style.cssText = 'color:#e05252;font-size:13px;margin-top:10px;text-align:center;';
    var btn = document.getElementById('hex-start-btn');
    btn.parentNode.insertAdjacentElement('afterend', msg);
    setTimeout(function () {
      var el = document.getElementById('hex-validation-msg');
      if (el) el.remove();
    }, 3000);
  }
  
  // ─── Init ─────────────────────────────────────────────────────────────────
  function init() {
    initDropdown('hex-dropdown-shape',    onShapeChange);
    initDropdown('hex-dropdown-material', onMaterialChange);
    initDropdown('hex-dropdown-size',     onSizeChange);
    initCollageCards();
    initStartButton();

    // Lees initiële waarden uit de al-geselecteerde items
        readInitialState();
    updatePriceDisplay();
  }

function applyUrlParams() {
    var p = new URLSearchParams(window.location.search);
    var map = {
      vorm: 'hex-dropdown-shape',
      materiaal: 'hex-dropdown-material',
      formaat: 'hex-dropdown-size'
    };
    Object.keys(map).forEach(function (key) {
      var val = p.get(key);
      if (!val) return;
      var li = document.querySelector('#' + map[key] + ' .hex-config__dropdown-item[data-value="' + val.replace(/"/g, '') + '"]');
      if (li) li.click();
    });
    var collage = p.get('collage');
    if (collage) {
      var c = collage.replace(/"/g, '');
      var card = document.querySelector('.hex-config__collage-card[data-value="' + c + '"], .hex-config__collage-card[data-layout="' + c + '"]');
      if (card) card.click();
    }
  }

function readInitialState() {
    const matSelected   = document.querySelector('#hex-dropdown-material .hex-config__dropdown-item.is-selected');
    const sizeSelected  = document.querySelector('#hex-dropdown-size .hex-config__dropdown-item.is-selected');
    const shapeSelected = document.querySelector('#hex-dropdown-shape .hex-config__dropdown-item.is-selected');

    if (matSelected)   state.material = matSelected.dataset.value;
    if (sizeSelected)  state.size     = sizeSelected.dataset.value;
    if (shapeSelected) state.shape    = shapeSelected.dataset.value;
    updateSizeDimsDisplay();
  }

  // ─── Dropdown factory ─────────────────────────────────────────────────────
  function initDropdown(wrapperId, onChange) {
    const wrapper = document.getElementById(wrapperId);
    if (!wrapper) return;

    const btn  = wrapper.querySelector('.hex-config__dropdown-btn');
    const list = wrapper.querySelector('.hex-config__dropdown-list');
    const items = list ? list.querySelectorAll('.hex-config__dropdown-item') : [];

    if (!btn || !list) return;

// Toggle open/dicht
btn.addEventListener('click', function (e) {
      e.stopPropagation();
      const isOpen = list.classList.contains('is-open');
      closeAllDropdowns();
      if (!isOpen) {
        list.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        // Verberg alleen het label van DEZE dropdown
var ownLabel = wrapper.querySelector('.hex-config__required-label');
        if (ownLabel) ownLabel.style.display = 'none';
      }
    });

    // Item selecteren
    items.forEach(function (item) {
      item.addEventListener('click', function () {
        items.forEach(function (i) {
          i.classList.remove('is-selected');
          i.setAttribute('aria-selected', 'false');
        });
        item.classList.add('is-selected');
        item.setAttribute('aria-selected', 'true');

        updateDropdownDisplay(wrapper, item);
        closeAllDropdowns();
        if (onChange) onChange(item.dataset.value, item);
      });

      // Keyboard toegankelijkheid
      item.setAttribute('tabindex', '0');
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          item.click();
        }
      });
    });
  }

  function updateDropdownDisplay(wrapper, selectedItem) {
    const nameEl  = wrapper.querySelector('.hex-config__dropdown-name');
    const descEl  = wrapper.querySelector('.hex-config__dropdown-desc');
    const thumbEl = wrapper.querySelector('.hex-config__dropdown-thumb');
    const badgeEl = wrapper.querySelector('.hex-config__dropdown-badge');
    const iconEl  = wrapper.querySelector('.hex-config__dropdown-icon');

if (nameEl && selectedItem.dataset.name) {
      var _itemNameEl = selectedItem.querySelector('.hex-config__dropdown-item-name');
      nameEl.textContent = (_itemNameEl ? _itemNameEl.textContent : null) || selectedItem.dataset.name;
      nameEl.classList.remove('hex-config__dropdown-placeholder');
      wrapper.querySelector('.hex-config__dropdown-btn').classList.add('has-value');
    }
    if (descEl && selectedItem.dataset.desc !== undefined) {
      descEl.textContent = selectedItem.dataset.desc || '';
    }

    // Kopieer het icoontje van het geselecteerde item naar de button
if (iconEl) {
      const itemIcon = selectedItem.querySelector('.hex-config__dropdown-item-icon');
      if (itemIcon) {
iconEl.innerHTML = itemIcon.innerHTML;
        iconEl.style.display = '';
      }
    }

    // Thumbnail updaten (materiaal dropdown)
if (thumbEl) {
      const imgSrc = selectedItem.dataset.img;
      if (imgSrc) {
        thumbEl.style.display = '';
        let img = thumbEl.querySelector('img');
        if (!img) {
          img = document.createElement('img');
          img.width  = 40;
          img.height = 40;
          thumbEl.appendChild(img);
        }
        img.src = imgSrc;
        img.alt = selectedItem.dataset.name || '';
      }
    }

    // Badge updaten (formaat dropdown) — toon badge alleen als dit item zelf populair is
    if (badgeEl) {
      const isPopular = selectedItem.dataset.popular === 'true';
      badgeEl.style.display = isPopular ? '' : 'none';
    }
  }

function closeAllDropdowns() {
    document.querySelectorAll('.hex-config__dropdown-list.is-open').forEach(function (list) {
      list.classList.remove('is-open');
      const btn = list.closest('.hex-config__dropdown')
                      .querySelector('.hex-config__dropdown-btn');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      // Herstel label van deze dropdown
      var wrapper = list.closest('.hex-config__dropdown');
var lbl = wrapper ? wrapper.querySelector('.hex-config__required-label') : null;
      if (lbl) lbl.style.display = 'block';
    });
    hideRequiredLabels(false);
  }

  // Klik buiten → sluit dropdowns
  document.addEventListener('click', closeAllDropdowns);

  // Escape → sluit dropdowns
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllDropdowns();
  });

  // ─── Change handlers ──────────────────────────────────────────────────────
function onShapeChange(value, item) {
    state.shape = value;
    updateShapeMedia(item);
    updateCollageImages(item);
    updateSizeDimsDisplay();
    checkAllSelected();
    updateUrl();
  }

function initCollageOriginals() {
    var cards = document.querySelectorAll('.hex-config__collage-card');
    cards.forEach(function(card) {
      var img = card.querySelector('.hex-config__collage-preview img');
      if (img) card.dataset.originalSrc = img.src;
    });
  }

  function updateCollageImages(item) {
    if (!item) return;
    var individual = item.dataset.collageIndividual;
    var mosaic     = item.dataset.collageMosaic;
    var cards      = document.querySelectorAll('.hex-config__collage-card');
    cards.forEach(function(card) {
      var layout = card.dataset.layout;
      var src    = layout === 'individual' ? individual : mosaic;
      var img    = card.querySelector('.hex-config__collage-preview img');
      if (!img) return;
      if (src && src.length > 10) {
        img.src = src;
      } else {
        var origSrc = card.dataset.originalSrc;
        if (origSrc) img.src = origSrc;
      }
    });
  }

  // Sla originele src op bij initialisatie (= hero van vorm 1)
  var originalHeroSrc = null;
  var originalThumbSrcs = [];

  function initOriginalMedia() {
    const mainImg = document.getElementById('hex-main-img');
    if (mainImg) originalHeroSrc = mainImg.src;
    const thumbBtns = document.querySelectorAll('.hex-thumbs__item');
    thumbBtns.forEach(function(btn) {
      const img = btn.querySelector('img');
      originalThumbSrcs.push({
        src: btn.dataset.src || '',
        small: img ? img.src : ''
      });
    });
  }

  function updateShapeMedia(item) {
    if (!item) return;

    const mainImg   = document.getElementById('hex-main-img');
    const thumbBtns = document.querySelectorAll('.hex-thumbs__item');

    // Wissel hoofdafbeelding — fallback naar origineel als geen hero ingesteld
    const newHero = item.dataset.hero;
    if (mainImg) {
      mainImg.src = (newHero && newHero.length > 10) ? newHero : originalHeroSrc;
    }

    // Wissel thumbnails
    const thumbData = [
      { src: item.dataset.thumb1, small: item.dataset.thumb1Small },
      { src: item.dataset.thumb2, small: item.dataset.thumb2Small },
      { src: item.dataset.thumb3, small: item.dataset.thumb3Small },
      { src: item.dataset.thumb4, small: item.dataset.thumb4Small },
    ].filter(function(t) { return t.src && t.src.length > 10; });

// Update eerste thumb altijd
    var currentMainSrc = (newHero && newHero.length > 10) ? newHero : originalHeroSrc;
    if (thumbBtns[0]) {
      thumbBtns[0].dataset.src = currentMainSrc;
      var firstThumbImg = thumbBtns[0].querySelector('img');
      if (firstThumbImg) firstThumbImg.src = currentMainSrc;
      thumbBtns[0].classList.add('is-active');
      thumbBtns[0].style.display = '';
    }

    if (thumbData.length === 0) {
      // Herstel originele thumbnails
      thumbBtns.forEach(function(btn, index) {
        if (index === 0) return;
        var origThumb = originalThumbSrcs[index] || null;
        if (origThumb && origThumb.src) {
          btn.dataset.src = origThumb.src;
          var img = btn.querySelector('img');
          if (img) img.src = origThumb.small || origThumb.src;
          btn.style.display = '';
          btn.classList.remove('is-active');
        } else {
          btn.style.display = 'none';
        }
      });
      return;
    }

    // Update bestaande thumb buttons, verberg overtollige
    thumbBtns.forEach(function(btn, index) {
      // Sla de eerste thumb over (= altijd hoofdafbeelding)
      const dataIndex = index - 1;
      if (index === 0) return; // al bijgewerkt hierboven
      const thumb = thumbData[dataIndex];
      const origThumb = originalThumbSrcs[index] || null;
      if (thumb) {
        btn.dataset.src = thumb.src;
        const img = btn.querySelector('img');
        if (img) img.src = thumb.small || thumb.src;
        btn.style.display = '';
        btn.classList.remove('is-active');
      } else if (origThumb && origThumb.src) {
        // Herstel originele thumbnail
        btn.dataset.src = origThumb.src;
        const img = btn.querySelector('img');
        if (img) img.src = origThumb.small || origThumb.src;
        btn.style.display = '';
        btn.classList.remove('is-active');
      } else {
        btn.style.display = 'none';
      }
    });
  }

function getDimsForShapeFromItem(item, shape) {
    if (!item) return '';
    switch (shape) {
      case 'hexagon':  return item.dataset.dimsHexagon  || '';
      case 'vierkant': return item.dataset.dimsVierkant || '';
      case 'rond':     return item.dataset.dimsRond     || '';
      default:         return item.dataset.dimsHexagon  || '';
    }
  }

  function updateSizeDimsDisplay() {
    var allSizeItems = document.querySelectorAll('#hex-dropdown-size .hex-config__dropdown-item');
    allSizeItems.forEach(function(item) {
      var dims = getDimsForShapeFromItem(item, state.shape);
      if (!dims) return;
      var baseVal  = item.dataset.value || '';
      var baseName = baseVal.charAt(0).toUpperCase() + baseVal.slice(1);
      var newName  = baseName + ' (' + dims + ')';
      var itemNameEl = item.querySelector('.hex-config__dropdown-item-name');
      if (itemNameEl) itemNameEl.textContent = newName;
      if (item.classList.contains('is-selected')) {
        var btnNameEl = document.querySelector('#hex-dropdown-size .hex-config__dropdown-name');
        if (btnNameEl) btnNameEl.textContent = newName;
      }
    });
  }

function onMaterialChange(value) {
    state.material = value;
    updatePriceDisplay();
    checkAllSelected();
    updateUrl();
  }

  function onSizeChange(value, item) {
    state.size = value;
    updatePriceDisplay();
    checkAllSelected();
    updateUrl();
  }
  // ─── Collage type cards ───────────────────────────────────────────────────
  function initCollageCards() {
    const cards = document.querySelectorAll('.hex-config__collage-card');
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        cards.forEach(function (c) {
          c.classList.remove('is-selected');
          c.setAttribute('aria-pressed', 'false');
        });
        card.classList.add('is-selected');
        card.setAttribute('aria-pressed', 'true');
state.layout = card.dataset.layout;
        checkAllSelected();
        updateUrl();
      });
    });
  }

var validationShown = false;

function updateUrl() {
    var params = new URLSearchParams(window.location.search);
    if (state.shape)    params.set('vorm', state.shape);
    if (state.material) params.set('materiaal', state.material);
    if (state.size)     params.set('formaat', state.size);
    if (state.layout)   params.set('collage', state.layout);
    var newUrl = window.location.pathname + '?' + params.toString();
    history.replaceState(null, '', newUrl);
  }

function hideRequiredLabels(hide) {
    document.querySelectorAll('.hex-config__required-label').forEach(function(el) {
      el.style.display = hide ? 'none' : 'block';
    });
  }

  function checkAllSelected() {
    var btn = document.getElementById('hex-start-btn');
    if (!btn) return;
    var allDone = state.shape && state.material && state.size && state.layout;
if (allDone) {
      btn.classList.remove('is-disabled');
    } else {
      btn.classList.add('is-disabled');
    }
    if (validationShown) highlightMissing();
  }

function highlightMissing() {
    markRequired('hex-dropdown-shape',    !state.shape,    'Kies jouw vorm');
    markRequired('hex-dropdown-material', !state.material, 'Kies het materiaal');
    markRequired('hex-dropdown-size',     !state.size,     'Kies het formaat');
    markCollageRequired(!state.layout);
  }

  function markRequired(id, isMissing, label) {
    var el = document.getElementById(id);
    if (!el) return;
    if (isMissing) {
      el.classList.add('is-required');
      if (!el.querySelector('.hex-config__required-label')) {
        var lbl = document.createElement('span');
        lbl.className = 'hex-config__required-label';
        lbl.textContent = '⚠ ' + label;
        el.appendChild(lbl);
      }
    } else {
      el.classList.remove('is-required');
      var lbl = el.querySelector('.hex-config__required-label');
      if (lbl) lbl.remove();
    }
  }

  function markCollageRequired(isMissing) {
    var cards = document.querySelectorAll('.hex-config__collage-card');
    var group = cards.length ? cards[0].closest('.hex-config__group') : null;
    cards.forEach(function(card) {
      if (isMissing) {
        card.classList.add('is-required');
      } else {
        card.classList.remove('is-required');
      }
    });
    if (!group) return;
    var lbl = group.querySelector('.hex-config__required-label');
    if (isMissing && !lbl) {
      var newLbl = document.createElement('span');
      newLbl.className = 'hex-config__required-label';
      newLbl.textContent = '⚠ Kies je collage';
      group.appendChild(newLbl);
    } else if (!isMissing && lbl) {
      lbl.remove();
    }
  }

  // ─── Start button ─────────────────────────────────────────────────────────
function initStartButton() {
    const btn = document.getElementById('hex-start-btn');
    if (!btn) return;

btn.classList.add('is-disabled');

    btn.addEventListener('click', function () {
if (!state.shape || !state.material || !state.size || !state.layout) {
        validationShown = true;
        highlightMissing();
        showValidationMessage();
        return;
      }

      const editorUrl = btn.dataset.editorUrl || '/pages/editor';

      // Zoek bestaande sessie voor dit product
      const existingSessionId = findExistingSession();
      if (existingSessionId) {
        // Bestaande sessie gevonden — ga direct naar editor
        window.location.href = editorUrl + '?session=' + existingSessionId;
        return;
      }

      // Geen bestaande sessie — nieuwe aanmaken
      const session = buildSessionObject();
      saveSession(session);
      window.location.href = editorUrl + '?session=' + session.session_id;
    });
  }

  function findExistingSession() {
    try {
      // Loop door alle localStorage keys en zoek hex_session_ entries
      var productId = window.hexProductConfig ? String(window.hexProductConfig.productId) : null;
      var productHandle = window.hexProductConfig ? window.hexProductConfig.productHandle : null;

      for (var i = 0; i < localStorage.length; i++) {
        var key = localStorage.key(i);
        if (!key || !key.startsWith('hex_session_')) continue;

        var raw = localStorage.getItem(key);
        if (!raw) continue;

        try {
          var session = JSON.parse(raw);

          // Alleen draft sessies met foto's tonen
          if (session.status !== 'draft') continue;
          if (!session.images || session.images.length === 0) continue;

          // Match op product
          var sessionProductId = session.shopify ? String(session.shopify.product_id) : null;
          var sessionHandle = session.shopify ? session.shopify.product_handle : null;

          if (productId && sessionProductId && productId === sessionProductId) {
            return session.session_id;
          }
          if (productHandle && sessionHandle && productHandle === sessionHandle) {
            return session.session_id;
          }
        } catch (e) {
          continue;
        }
      }
    } catch (e) {
      return null;
    }
    return null;
  }

  // ─── Session object ───────────────────────────────────────────────────────
  function buildSessionObject() {
    var variant = findVariant(state.material, state.size);

    return {
      session_id:  generateId(),
      created_at:  new Date().toISOString(),
      status:      'draft',

      product: {
        shape:    state.shape,
        material: state.material,
        size:     state.size,
      },

      layout_type: state.layout,  // 'individual' | 'mosaic'

      // Grid wordt gevuld door de editor zodra foto's geüpload zijn
      grid: {
        total_hexagons: 0,
        rings:          0,
        positions:      [],
      },

      // Editor state — wordt gevuld in de editor
      images:  [],
      filters: {},

      // Shopify context
      shopify: {
        product_id:     window.hexProductConfig ? window.hexProductConfig.productId     : null,
        product_handle: window.hexProductConfig ? window.hexProductConfig.productHandle : null,
        variant_id:     variant ? variant.id    : null,
        price:          variant ? variant.price : null,
      },
    };
  }

  function saveSession(session) {
    try {
      // Sla op in localStorage
      localStorage.setItem('hex_session_' + session.session_id, JSON.stringify(session));
      // Bewaar ook de laatste session ID voor makkelijk terugvinden
      localStorage.setItem('hex_last_session', session.session_id);
    } catch (e) {
      console.warn('[Hex] localStorage niet beschikbaar:', e);
    }
  }

  // ─── Utilities ────────────────────────────────────────────────────────────
  function generateId() {
    // Eenvoudige UUID v4 zonder crypto dependency
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  // ─── Start ────────────────────────────────────────────────────────────────
function start() {
    try{Object.keys(localStorage).filter(function(k){return k.indexOf('hex_')===0;}).forEach(function(k){localStorage.removeItem(k);});}catch(e){}
    init();
    initOriginalMedia();
    initCollageOriginals();
    applyUrlParams();
    checkExistingSession();
  }
  function checkExistingSession() {
    var existingId = findExistingSession();
    var btn = document.getElementById('hex-start-btn');
    if (existingId && btn) {
      btn.textContent = 'Verder ontwerpen';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

// ─── Thumbnail carrousel ───────────────────────────────────────────────────
(function initThumbs() {
  const thumbs = document.querySelectorAll('.hex-thumbs__item');
  const mainImg = document.getElementById('hex-main-img');
  if (!thumbs.length || !mainImg) return;

  // Sla de originele src op als fallback
  const originalSrc = mainImg.src;

  // Eerste thumbnail krijgt data-src van de hoofdafbeelding als fallback
  thumbs.forEach(function (thumb, index) {
    thumb.addEventListener('click', function () {
      const newSrc = thumb.dataset.src;
      // Alleen wisselen als er een geldige src is
      if (newSrc && newSrc.length > 10 && !newSrc.startsWith('data:')) {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        mainImg.src = newSrc;
      }
    });
  });

  // Eerste thumb is altijd de hoofdafbeelding zelf
  const firstThumb = thumbs[0];
  if (firstThumb && !firstThumb.dataset.src) {
    firstThumb.dataset.src = originalSrc;
  }
})();

// ─── Review carrousel ─────────────────────────────────────────────────────
(function initReviews() {
  const slider = document.getElementById('hex-reviews-slider');
  if (!slider) return;
  const slides = slider.querySelectorAll('.hex-reviews__slide');
  const dotsWrap = document.getElementById('hex-reviews-dots');
  const dots   = dotsWrap ? dotsWrap.querySelectorAll('.hex-reviews__dot') : [];
  const btnPrev = document.getElementById('hex-reviews-prev');
  const btnNext = document.getElementById('hex-reviews-next');
  if (!slides.length) return;

  let current = 0;

  function goTo(index) {
    slides[current].classList.remove('is-active');
    if (dots[current]) dots[current].classList.remove('is-active');
    current = (index + slides.length) % slides.length;
    slides[current].classList.add('is-active');
    if (dots[current]) dots[current].classList.add('is-active');
  }

  if (btnPrev) btnPrev.addEventListener('click', function () { goTo(current - 1); });
  if (btnNext) btnNext.addEventListener('click', function () { goTo(current + 1); });

  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () { goTo(i); });
  });

  // Auto-play elke 5 seconden
  setInterval(function () { goTo(current + 1); }, 5000);
})();

// ─── Review carrousel — mobiel ────────────────────────────────────────────
(function initReviewsMobile() {
  const slider  = document.getElementById('hex-reviews-slider-mobile');
  if (!slider) return;

  const slides  = slider.querySelectorAll('.hex-reviews__slide');
  const dots    = document.querySelectorAll('#hex-reviews-dots-mobile .hex-reviews__dot');
  const btnPrev = document.getElementById('hex-reviews-prev-mobile');
  const btnNext = document.getElementById('hex-reviews-next-mobile');
  if (!slides.length) return;

  let current = 0;

  function goTo(index) {
    slides[current].classList.remove('is-active');
    if (dots[current]) dots[current].classList.remove('is-active');
    current = (index + slides.length) % slides.length;
    slides[current].classList.add('is-active');
    if (dots[current]) dots[current].classList.add('is-active');
  }

  if (btnPrev) btnPrev.addEventListener('click', function () { goTo(current - 1); });
  if (btnNext) btnNext.addEventListener('click', function () { goTo(current + 1); });
  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () { goTo(i); });
  });

  setInterval(function () { goTo(current + 1); }, 5000);
})();